import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as", "variant", "semanticColor"];
import React from 'react';
import { spacer16 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { Type } from "../Type";
var EmptyStateTitleComponent = styled(Type).withConfig({
  displayName: "EmptyStateTitle__EmptyStateTitleComponent",
  componentId: "sc-1x0dyip-0"
})(["padding-block-end:", ";overflow-wrap:break-word;"], spacer16);
export var EmptyStateTitle = function EmptyStateTitle(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'heading3' : _ref$variant,
      _ref$semanticColor = _ref.semanticColor,
      semanticColor = _ref$semanticColor === void 0 ? 'textBase' : _ref$semanticColor,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(EmptyStateTitleComponent, Object.assign({
    forwardedAs: as,
    variant: variant,
    semanticColor: semanticColor
  }, props));
};
/**
* **EmptyStateTitle** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/EmptyStateTitle) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-emptystate-emptystatetitle--default) |  
*
* EmptyStateTitle is used to suggest an action or convey a benefit.
*
* @example
* () => <EmptyStateTitle>No content found</EmptyStateTitle>;
*
*/

export default EmptyStateTitle;